export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-thumbnails-6da66e16b725c0da1dc2640ab5f2c56e.svg";